<template>
   <video-player 
        class="video-player-box"
        ref="videoPlayer"
        :playsinline="true"
        style="object-fit:contain"
        :options="playerOptions"
        @play="onPlayerPlay($event)"
   >
   </video-player>
</template>

<script>
import 'videojs-contrib-hls'
import 'video.js/dist/video-js.css'
import { videoPlayer } from 'vue-video-player'

export default {
    name: 'videoPlay',
    props: {
        autoplay: {
            type: Boolean,
            default: false
        },
        src: {
            type: String,
            required: true
        },
        control: {
            type: Boolean,
            default: true
        },
        muted: {
            type: Boolean,
            default: true
        },
        loop: {
            type: Boolean,
            default: false
        },
        aspectRatio: {
            type: String,
            default: '16:9'
        },
        poster: {
            type: String,
            default: ''
        },
        fullscreenToggle: {
            type: Boolean,
            default: true
        },
        remainingTimeDisplay: {
            type: Boolean,
            default: false
        },
        fluid: {
            type: Boolean,
            default: true
        },
        timeDivider: {
            type: Boolean,
            default: true
        },
        durationDisplay: {
            type: Boolean,
            default: true
        },
        type: {
            type: String,
            default: 'application/x-mpegURL'
        }
    },
    data() {
        return {
            isPlaying: false,
            playerOptions: {
                flash: { hls: { withCredentials: false }},//可以使用rtmp视频
                html5: { hls: { withCredentials: false }},//可以使用m3u8视频
                controls: this.control, //是否显示控制条
                autoplay: this.autoplay, 
                muted: this.muted, //默认情况下会消除任何音频
                loop: this.loop, //视频结束就会重新开始
                preload: 'auto', //auto浏览器选择最佳行为,立即开始加载视频(如果浏览器支持)
                language: 'zh-CN',
                aspectRatio: this.aspectRatio, //将播放器置于流畅模式,并在计算播放器的动态大小时使用该值。
                fluid: this.fluid, //当true时,Video.js player将拥有流体大小。换句话说,它将按比例缩放以适应容器。
                sources: [{
                    type: this.type,
                    src: this.src
                }],
                poster: this.poster,
                width: document.documentElement.clientWidth,
                notSupportedMessage: '此视频无法播放,请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                controlBar: {
                    timeDivider: this.timeDivider, //当前时间和持续时间的分隔符
                    durationDisplay: this.durationDisplay, // 是否显示持续时间
                    remainingTimeDisplay: this.remainingTimeDisplay, //是否显示剩余时间
                    fullscreenToggle: this.fullscreenToggle //全屏按钮
                }
            }
        }
    },
    computed: {
        player() {
            return this.$refs.videoPlayer.player
        }
    },
    methods: {
        onPlayerPlay(player) {
            const myPlayer = this.$refs.videoPlayer.player;
            myPlayer.play();
        }
    },
    components: {
        videoPlayer
    }
}
</script>

<style lang="scss" scoped>
.video-player-box /deep/ .vjs-big-play-button {
  font-size: 14px !important;
  width: 40px !important;
  height: 40px !important;
  line-height: 40px !important;
  left: 50% !important;
  top: 50% !important;
  transform: translate(-50%, -50%);
  border-radius: 100% !important;
  z-index: 100;
  border: 1px solid #979797;
}
</style>


// WEBPACK FOOTER //
// src/components/videoPlayer.vue